export default {
      id: "icon--whatsapp-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "./../Views/Shared/_SvgSprite.cshtml#icon--whatsapp",
      toString: function () {
        return this.url;
      }
    }